import { BatchEndpoints } from '@/modules/arbela-gift-card/batch/api/batchEndpoints'

/**
 * Batch endpoint instance
 * instantiate Batch api class with different api path
 */
export const batchEndpoints = new BatchEndpoints()
